import { Helmet } from "react-helmet-async";

const DEFAULTS = {
  siteName: "HAEVN",
  title: "HAEVN | Modern Matchmaking",
  description:
    "HAEVN is modern, technology-enabled matchmaking. Define your intent, receive verified matches every Monday, and connect only when both members qualify.",
  image: "/og-image.jpg?v=2",
  type: "website",
};

export default function SEO({
  title,
  description,
  path = "",
  image,
  type,
  noindex = false,
}) {
  // Pages pass their full SEO title verbatim (e.g. "HAEVN Austin | Join the First Match Monday").
  // We no longer auto-append "| HAEVN" so each route owns its exact title.
  const pageTitle = title || DEFAULTS.title;
  const pageDescription = description || DEFAULTS.description;
  const rawImage = image || DEFAULTS.image;
  // Facebook / Twitter / iMessage require ABSOLUTE og:image URLs; relative
  // paths silently fail to preview. Resolve relative paths against the
  // canonical origin so every route ships an absolute URL.
  const pageImage = rawImage.startsWith("http")
    ? rawImage
    : `https://haevn.co${rawImage.startsWith("/") ? "" : "/"}${rawImage}`;
  const pageType = type || DEFAULTS.type;
  const canonical = `https://haevn.co${path}`;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:image" content={pageImage} />
      <meta property="og:type" content={pageType} />
      <meta property="og:url" content={canonical} />
      <meta property="og:site_name" content={DEFAULTS.siteName} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="twitter:image" content={pageImage} />
    </Helmet>
  );
}
